<div style="padding: 5% 5% 5% 5%;text-align: center;">
    <div style="border: 1px solid black;">
    <div style="display: flex;align-items: center;justify-content: center;padding-top: 5%;">
        <img src="assets/svg/ai.svg" class="image_ai" style="">
    </div>
    <div class="ai_header">
        "Sharkify AI Feature : Coming Soon!""
    </div>
</div>
</div>